<template>
	<div></div>
</template>

<script>
	import {
		getItem,
		traceAuth
	} from '@/utils/auth'
	export default {
		data() {
			return {
				languageJson: languageJson,
				socket: null,
				timeoutObj: null,
				reconnectTimer: null,
				timeout: 30 * 1000,
				socketUrl: "",
				timeEnd: 0,
				isDestroyed: false,
				retryNotified: false
			}
		},
		props: ['nowTime'],
		mounted() {
			let that = this
			// that.socketUrl = 'ws://192.168.31.211:10100/imserver/' + getItem('userInfo').account + '_' + this.nowTime.toString() + '_' + getItem('userInfo').tenantInfoId
			that.socketUrl = config.socketUrl + getItem('userInfo').account + '_' + this.nowTime.toString() + '_' +
				getItem('userInfo').tenantInfoId
			that.initWebSocket(that.socketUrl)
		},
		methods: {
			initWebSocket(url) {
				if (this.isDestroyed) return
				this.timeEnd++;
				if (this.timeEnd > 3) {
					// 连续失败只提示一次，之后降速重试；网络恢复前不清登录态，避免大屏挂机被踢回登录页
					if (!this.retryNotified) {
						this.retryNotified = true
						traceAuth('信令连续重连失败' + this.timeEnd + '次，已降速至30秒重试（未登出）')
						this.$notify.warning({
							title: '信令连接不稳定，正在自动重试'
						})
					}
					this.scheduleReconnect(url, 30000)
					return
				}
				if (typeof WebSocket === 'undefined') {
					alert('您的浏览器不支持socket')
				} else {
					this.socket = new WebSocket(url)
					this.socket.onopen = this.open
					this.socket.onerror = this.error
					this.socket.onmessage = this.getMessage
					this.socket.onclose = this.websocketclose
				}
			},
			scheduleReconnect(url, delay) {
				if (this.isDestroyed) return
				clearTimeout(this.reconnectTimer)
				this.reconnectTimer = setTimeout(() => {
					this.initWebSocket(url)
				}, delay)
			},
			open() {
				var self = this
				// 连接成功后清零，否则长时间挂机的偶发断连会累加到阈值触发登出
				self.timeEnd = 0
				self.retryNotified = false
				self.timeoutObj = window.setInterval(function() {
					if (self.socket && self.socket.readyState === 1) {
						self.socket.send('heartCheck')
					}
				}, self.timeout)
			},
			error() {
				// 失败后的重连统一由 onclose 处理，这里不直接登出
			},
			getMessage(event) {
				let that = this
				if (event.data !== '连接成功') {
					let socketData = JSON.parse(event.data)
					if (socketData.socketType !== '5') {
						that.$emit('backSockertData', socketData)
					}
				}
			},
			websocketclose() {
				let self = this
				window.clearInterval(self.timeoutObj)
				self.socket = null
				// 原实现是同步立即重连，网络瞬断时几次失败会在毫秒内跑完并触发登出
				self.scheduleReconnect(self.socketUrl, 5000)
			}
		},
		destroyed() {
			let that = this
			that.isDestroyed = true
			window.clearInterval(that.timeoutObj)
			clearTimeout(that.reconnectTimer)
			that.socket = null
		}
	}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/IndexSocket.vue